import React from 'react';
import { ReactComponent as CloseImage } from '@assets/svg/small-cross.svg';
import { BActionIcon } from '@components/BActionIcon/BActionIcon';

interface CloseBtnProps {
  onClick?: VoidFunction;
}
export function CloseBtn({ onClick }: CloseBtnProps) {
  return (
    <BActionIcon size={20} radius={4} onClick={onClick}>
      <CloseImage width={16} height={16} />
    </BActionIcon>
  );
}
